import styled from 'astroturf/react'
import { BareButton } from '@calendly/ui/components/bare-button'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
const colorTextStandard = 'var(--colorTextStandard, var(--coreColorNeutral900))'
const fontWeightStandard = 'var(--fontWeightStandard, 400)'
const fontSizeMedium = 'var(--fontSizeMedium, 0.875rem)'
const fontWeightBold = 'var(--fontWeightBold, 700)'

import UnstyledTimezonePreview from './timezone_preview'
import _TimezonePreview from "styles-TimezonePreview.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/collapsible_spot_times/styles.js?styleId=TimezonePreview";
import _Wrapper from "styles-Wrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/collapsible_spot_times/styles.js?styleId=Wrapper";
import _Control from "styles-Control.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/collapsible_spot_times/styles.js?styleId=Control";
import _Container from "styles-Container.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/collapsible_spot_times/styles.js?styleId=Container";
import _SpotTimes from "styles-SpotTimes.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/collapsible_spot_times/styles.js?styleId=SpotTimes";
import _ExpandButton from "styles-ExpandButton.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/collapsible_spot_times/styles.js?styleId=ExpandButton";
import _GroupSpots from "styles-GroupSpots.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/collapsible_spot_times/styles.js?styleId=GroupSpots";
import _GroupSpotDetails from "styles-GroupSpotDetails.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/collapsible_spot_times/styles.js?styleId=GroupSpotDetails";
import _GroupSpotDate from "styles-GroupSpotDate.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/collapsible_spot_times/styles.js?styleId=GroupSpotDate";
import _GroupSpotTimes from "styles-GroupSpotTimes.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/collapsible_spot_times/styles.js?styleId=GroupSpotTimes";


const TimezonePreview = /*#__PURE__*/styled(UnstyledTimezonePreview, null, {
  displayName: "TimezonePreview",
  styles: _TimezonePreview,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

const Wrapper = /*#__PURE__*/styled('div', null, {
  displayName: "Wrapper",
  styles: _Wrapper
})

const Control = /*#__PURE__*/styled('div', null, {
  displayName: "Control",
  styles: _Control
})

const Container = /*#__PURE__*/styled('div', null, {
  displayName: "Container",
  styles: _Container
})

const SpotTimes = /*#__PURE__*/styled('div', null, {
  displayName: "SpotTimes",
  styles: _SpotTimes
})

const ExpandButton = /*#__PURE__*/styled(BareButton, null, {
  displayName: "ExpandButton",
  styles: _ExpandButton
})

const GroupSpots = /*#__PURE__*/styled('div', null, {
  displayName: "GroupSpots",
  styles: _GroupSpots
})

const GroupSpotDetails = /*#__PURE__*/styled('div', null, {
  displayName: "GroupSpotDetails",
  styles: _GroupSpotDetails
})

const GroupSpotDate = /*#__PURE__*/styled('div', null, {
  displayName: "GroupSpotDate",
  styles: _GroupSpotDate
})

const GroupSpotTimes = /*#__PURE__*/styled('div', null, {
  displayName: "GroupSpotTimes",
  styles: _GroupSpotTimes
})

export {
  SpotTimes,
  Wrapper,
  Control,
  Container,
  ExpandButton,
  GroupSpots,
  GroupSpotDetails,
  GroupSpotDate,
  GroupSpotTimes,
  TimezonePreview
}
